export default "__VITE_ASSET__BGbiduFp__"